<ax-panel-box [caption]="internalCaption" [allowCollapse]="allowCollapse"  [collapsed]="collapsed" *ngIf="visible">
    <ng-container *ngFor="let w of widgets" axf-widget-renderer [widget]="w" mode='view' [parent]="this" >
    </ng-container>
</ax-panel-box>

